import { defineComponent as _defineComponent } from 'vue'
import type { ViewProperties } from '@/models/ViewProperties'
import type { Registration } from '@/types/Registration'
import type { PropType } from 'vue'
import { ref } from 'vue'
import { registrationService } from '@/services/RegistrationService'
import { toastService } from 'affolternet-vue3-library'


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketsRegistrations',
  props: {
  viewProperties: {
    required: true,
    type: Object as PropType<ViewProperties>
  },
},
  emits: ['calendar-updated'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props



const adding = ref(false)


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const saveReservation = async (registration: Registration, seatId: string) => {
  const result = await registrationService.createReservation({
    calendarFile: props.viewProperties.filename,
    gameId: props.viewProperties.game.uid,
    seatId,
    firstName: registration.firstname,
    lastName: registration.lastname,
    phone: registration.phone,
    email: registration.email,
    notes: registration.notes,
  })
  if (result.success && result.data.calendar) {
    adding.value = false
    emit('calendar-updated', result.data.calendar)
    return
  }

  if (result.response.status === 409) {
    toastService.showWarning('Dieser Sitz wurde gerade reserviert. Die Spiele werden neu geladen.')
    emit('calendar-updated', null)
    return
  }

  toastService.showError('Die Reservierung konnte nicht gespeichert werden.')
}

const __returned__ = { props, adding, emit, saveReservation, ref, registrationService, toastService }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})